import {
  ADD_CARD,
  CLEAR_CARD_DETAILS,
  GET_CARD_DETAILS,
  SET_ACCOUNT_STATUS,
  SET_AVAILABLE_CARDS,
  SET_CARD_ERROR,
  SET_CARD_SETTINGS,
  SET_CARD_TRACKING_INFO,
  SET_CARDS,
  SET_HAS_CARDS,
  UNSET_CARD_ERROR,
  UPDATE_CARD,
  UPDATE_CURRENT_CARD,
} from '@portal/actions/actionTypes';
import {
  AddCardAction,
  SetAvailableCardsAction,
  SetCardErrorAction,
  SetCardsAction,
  SetCardSettingsAction,
  UpdateCardAction,
} from '@portal/actions/cards';

export const initialState: reducers.CardsState = {
  cards: [],
  currentCard: null,
  newCard: null,
  error: null,
  canCreateCard: false,
  availableCards: null,
  settings: null,
  hasCards: null,
  cardDetails: null,
  trackingInfo: null,
  accountDockStatus: null,
};

const cardsReducer = (
  state = initialState,
  action:
    | AddCardAction
    | SetCardErrorAction
    | SetCardsAction
    | SetCardSettingsAction
    | UpdateCardAction
    | SetAvailableCardsAction
) => {
  const { type, payload } = action;
  if (payload instanceof Error && type === SET_CARD_ERROR) {
    return {
      ...state,
      error: payload,
    };
  }
  switch (type) {
    case SET_CARDS:
      if (!Array.isArray(payload)) {
        return state;
      }

      return {
        ...state,
        cards: payload,
      };
    case SET_HAS_CARDS:
      return {
        ...state,
        hasCards: payload,
      };
    case UPDATE_CURRENT_CARD:
      if (!('embossingName' in payload)) {
        return state;
      }

      return {
        ...state,
        currentCard: {
          ...state.currentCard,
          ...payload,
        },
      };
    case UPDATE_CARD: {
      if (!('card' in payload)) {
        return state;
      }

      const thisCard = state.cards.find((card) => card.id === payload.id);
      if (!thisCard) {
        return state;
      }

      return {
        ...state,
        cards: [
          ...state.cards.filter((stateCard) => stateCard.id !== payload.id),
          {
            ...thisCard,
            ...payload.card,
          },
        ],
      };
    }
    case ADD_CARD:
      if (!('embossingName' in payload)) {
        return state;
      }

      return {
        ...state,
        error: null,
        cards: [...state.cards, payload],
      };
    case SET_CARD_SETTINGS:
      if (!('reasonTypesDuplicateCard' in payload)) {
        return state;
      }

      return {
        ...state,
        settings: payload,
        error: null,
      };
    case UNSET_CARD_ERROR:
      return {
        ...state,
        error: null,
      };
    case SET_AVAILABLE_CARDS:
      if (!('physical' in payload)) {
        return state;
      }
      return {
        ...state,
        availableCards: payload,
      };
    case CLEAR_CARD_DETAILS:
      return {
        ...state,
        cardDetails: null,
      };
    case GET_CARD_DETAILS:
      return {
        ...state,
        cardDetails: payload,
      };
    case SET_CARD_TRACKING_INFO:
      return {
        ...state,
        trackingInfo: payload,
      };
    case SET_ACCOUNT_STATUS:
      return {
        ...state,
        accountDockStatus: payload,
      };
    default:
      return state;
  }
};

export default cardsReducer;
